<form autocomplete="off" class="p-0" novalidate [formGroup]="photoSignDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-1">
            <h5 class="main-content-label fw-bold mb-2">Update Student Details</h5>

            <!-- Row 1: Photo | Signature | ABC ID | Gender -->
            <div class="row g-2 mb-2 align-items-stretch">
                <div class="col-lg-3 col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Photo <span class="redCol">*</span></label>
                        <div class="upload-container mt-2">
                            <img *ngIf="!userImage"
                                 src="../../assets/images/user2.png"
                                 class="default-img" />
                            <img *ngIf="userImage"
                                 [src]="userImage"
                                 class="img-preview" />
                        </div>

                        <div class="text-center mt-1" *ngIf="updateButton">
                            <input #fileUpload type="file" hidden (change)="onChange1($event)" accept=".jpg,.jpeg" />
                            <button type="button"
                                    class="btn btn-sm btn-outline-primary px-2 py-1"
                                    matTooltip="JPG/JPEG • 200×230px to 500×530px • Max 50KB"
                                    (click)="fileUpload.click()">
                                <i class="ai-upload me-1 small"></i>Upload
                            </button>
                        </div>

                        <mat-error *ngIf="photoSignDetailsForm.controls['StuPhoto'].touched
                                && photoSignDetailsForm.controls['StuPhoto'].errors?.required"
                                   class="mat-error text-center small">
                            Photo required
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Signature <span class="redCol">*</span></label>
                        <div class="signature-container mt-2">
                            <img *ngIf="!signatureImage"
                                 src="../../assets/images/sign.png"
                                 class="default-sign" />
                            <img *ngIf="signatureImage"
                                 [src]="signatureImage"
                                 class="img-preview" />
                        </div>

                        <div class="text-center mt-1" *ngIf="updateButton">
                            <input #fileUpload2 type="file" hidden (change)="onChangeSign($event)" accept=".jpg,.jpeg" />
                            <button type="button"
                                    class="btn btn-sm btn-outline-primary px-2 py-1"
                                    matTooltip="JPG/JPEG • 140×60px to 300×300px • Max 20KB"
                                    (click)="fileUpload2.click()">
                                <i class="ai-upload me-1 small"></i>Upload
                            </button>
                        </div>

                        <mat-error *ngIf="photoSignDetailsForm.controls['StuSignature'].touched
                                && photoSignDetailsForm.controls['StuSignature'].errors?.required"
                                   class="mat-error text-center small">
                            Signature required
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">
                            ABC ID <span class="redCol">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <input matInput
                                   formControlName="StuABCId2"
                                   placeholder="Enter ABC ID"
                                   maxlength="12"
                                   class="small">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('StuABCId2', 'required')" class="small">
                            ABC ID required
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">
                            Gender <span class="redCol">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <mat-select #select1 formControlName="StuGender" placeholder="Select">
                                <mat-select-filter *ngIf="select1.focused"
                                                   [placeholder]="'Filter'"
                                                   [displayMember]="'CdDesc'"
                                                   [array]="genderList"
                                                   (filteredReturn)="filteredGenderList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredGenderList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('StuGender', 'required')" class="small">
                            Gender required
                        </mat-error>
                    </div>
                </div>
            </div>

            <!-- Row 2: Birth Date | Email | Mobile | Aadhaar -->
            <div class="row g-2 mb-2 align-items-stretch">
                <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">
                            Birth Date <span class="redCol">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <input matInput
                                   type="date"
                                   formControlName="BirthDate"
                                   [max]="TODAY_DATE"
                                   class="small">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('BirthDate', 'required')" class="small">
                            Birth date required
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Email <span class="redCol">*</span></label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <input matInput
                                   type="email"
                                   formControlName="Email"
                                   placeholder="Email"
                                   class="small">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('Email', 'required')" class="small">
                            Email required
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Mobile <span class="redCol">*</span></label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <input matInput
                                   type="tel"
                                   formControlName="MobNo"
                                   placeholder="Mobile"
                                   maxlength="10"
                                   class="small">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('MobNo', 'required')" class="small">
                            Mobile required
                        </mat-error>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Aadhaar <span class="redCol">*</span></label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <input matInput
                                   type="text"
                                   formControlName="AdharNo"
                                   placeholder="Aadhaar"
                                   maxlength="12"
                                   class="small">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('AdharNo', 'required')" class="small">
                            Aadhaar required
                        </mat-error>
                    </div>
                </div>
            </div>

            <!-- Row 3: Admission Quota Category | District | Taluka (3 × col-lg-4) -->
            <div class="row g-2 mb-2 align-items-stretch">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Admission Quota Category</label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <mat-select
                                formControlName="AdmissionQuotaCategory"
                                placeholder="Select Admission Quota Category"
                                [disabled]="disabled">
                                <mat-option *ngFor="let quota of filteredAdmissionQuotaCategoryList" [value]="quota.CdCode">
                                    {{quota.CdDesc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">District</label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <mat-select #selectDistrict formControlName="StuDistrict" placeholder="Select"
                                        (selectionChange)="onDistrictChange($event)">
                                <mat-select-filter *ngIf="selectDistrict.focused"
                                                   [placeholder]="'Filter'"
                                                   [displayMember]="'DsName'"
                                                   [array]="districtList"
                                                   (filteredReturn)="filteredDistrictList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredDistrictList" [value]="item.DsCode">
                                    {{item.DsName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="card shadow-sm p-2 h-100 d-flex flex-column">
                        <label class="form-label small fw-bold mb-0">Taluka</label>
                        <mat-form-field appearance="outline" class="w-100 small" floatLabel="never">
                            <mat-select #selectTehsil formControlName="StuTehsil" placeholder="Select">
                                <mat-select-filter *ngIf="selectTehsil.focused"
                                                   [placeholder]="'Filter'"
                                                   [displayMember]="'TsName'"
                                                   [array]="districtTehsilList"
                                                   (filteredReturn)="filteredTehsilList = $event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredTehsilList" [value]="item.TsCode">
                                    {{item.TsName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="button-container d-flex justify-content-end mt-2">
                <button id="Back"
                        type="button"
                        [mat-dialog-close]="true"
                        class="btn btn-sm btn-outline-secondary px-2 py-1 me-1">
                    <i class="ai-arrow-left me-1"></i>Back
                </button>

                <button *ngIf="updateButton"
                        type="button"
                        [disabled]="disabled || isSaving"
                        (click)="updateCheck()"
                        class="btn btn-sm btn-primary px-2 py-1">
                    <i *ngIf="!isSaving" class="ai-save me-1"></i>
                    <i *ngIf="isSaving" class="fas fa-spinner fa-spin me-1"></i>
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
            </div>
        </div>
    </div>
</form>